import { CmsObjectWithDefault } from '@components/Cms/types';

export type ChangePasswordViewCmsKey = 'NewPassword' | 'ConfirmNewPassword' | 'EnterNewPasswordFor' | 'ChangePassword';

export const ChangePasswordViewCmsWithDefault: CmsObjectWithDefault<ChangePasswordViewCmsKey> = {
    NewPassword: {
        cmsId: 67072,
        defaultTranslation: 'New Password',
    },
    ConfirmNewPassword: {
        cmsId: 67073,
        defaultTranslation: 'Confirm New password',
    },
    EnterNewPasswordFor: {
        cmsId: 82996,
        defaultTranslation: 'Enter a new password for:',
    },
    ChangePassword: {
        cmsId: 67074,
        defaultTranslation: 'Change Password',
    },
};
